import { useState, useEffect } from "react";
import { directusService } from "@/services/directus";
import { MatchPrediction } from "@/types/app";

export const useMatchPrediction = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [hasActiveMatch, setHasActiveMatch] = useState(false);

  useEffect(() => {
    checkForActiveMatches();
  }, []);

  const checkForActiveMatches = async () => {
    try {
      const matches = await directusService.getActiveMatches();
      if (matches && matches.length > 0) {
        setHasActiveMatch(true);

        // Vérifier si l'utilisateur a déjà soumis un pronostic pour TOUS les matchs
        const submittedMatches = JSON.parse(
          localStorage.getItem("submittedPredictions") || "[]"
        );

        const hasUnsubmittedMatches = matches.some(
          (match) => !submittedMatches.includes(match.id)
        );

        // Ne pas afficher si tous les matchs ont déjà été soumis
        if (!hasUnsubmittedMatches) {
          return;
        }

        // Vérifier si l'utilisateur a déjà vu le dialog aujourd'hui
        const lastShownDate = localStorage.getItem("lastMatchPredictionShown");
        const today = new Date().toDateString();

        if (lastShownDate !== today) {
          // Afficher le dialog après 3 secondes
          setTimeout(() => {
            setShowDialog(true);
            localStorage.setItem("lastMatchPredictionShown", today);
          }, 3000);
        }
      }
    } catch (error: any) {
      // Erreur silencieuse si les permissions Directus ne sont pas configurées
      if (error?.response?.status !== 403) {
        console.error("Error checking for active matches:", error);
      }
    }
  };

  return {
    showDialog,
    setShowDialog,
    hasActiveMatch,
  };
};
